import { getAuth } from 'firebase/auth'
import { API_METHODS, buildRoutePath } from '../constants/routes'
import { formStates } from '../constants/helper-states'
import { upsertForm } from './form'

import isEqual from 'lodash/isEqual'

import moment from 'moment'

const API_URL = process.env.REACT_APP_API_URL

const apiAction = (type, data) => {
    return { type, data }
}

const apiListAction = (data) => {
    if (data.length > 0 && '_key' in data[0]) {
        return { type: `SAVE_${data[0]._key}_LIST`, data }
    }
    return { type: null }
}

const apiSingleAction = (data) => {
    if (data && '_key' in data) {
        return { type: `SAVE_${data._key}`, data }
    }
    return { type: null }
}

const apiRemoveAction = (data) => {
    if (data && '_key' in data) {
        return { type: `REMOVE_${data._key}`, data }
    }
    return { type: null }
}

const checkForObjEquality = (data, updateObj) => {
    if (!('_key' in data)) {
        return updateObj
    }
    let key = data._key
    let dataCopy = { ...data }
    let objCopy = { ...updateObj }
    delete dataCopy._related
    if (key in objCopy) {
        let match = false
        objCopy[key].forEach(keyData => {
            if (match) {
                return
            }
            // remove the related from the objs
            if (isEqual(keyData, dataCopy)) {
                // console.log('saving a match')
                match = true
                return
            }
        })
        if (!match) {
            objCopy[key].push(dataCopy)
        }
    } else {
        objCopy[key] = [dataCopy]
    }
    return objCopy
}

export const manageApiData = (data, updateObj = {}, depth = 0) => {
    let uObj = { ...updateObj }
    if (!data || (Array.isArray(data) && data.length === 0)) {
        if (depth === 0) {
            return dispatch => {
                return { type: null }
            }
        }
        return updateObj
    } else if (Array.isArray(data)) {
        data.forEach(item => {
            if (item && '_related' in item) {
                Object.keys(item._related).forEach(relation => {
                    let relatedObj = manageApiData(item._related[relation], uObj, depth + 1)
                    uObj = { ...relatedObj }
                })
            }
            let myObj = checkForObjEquality(item, uObj)
            uObj = { ...myObj }
        })
        if (depth > 0) {
            return uObj
        }
    } else {
        if ('_related' in data) {
            Object.keys(data._related).forEach(relation => {
                let relatedObj = manageApiData(data._related[relation], uObj, depth + 1)
                uObj = { ...relatedObj }
            })
        }
        let myObj = checkForObjEquality(data, uObj)
        uObj = { ...myObj }
        if (depth > 0) {
            return uObj
        }
    }
    if (depth === 0) {
        return dispatch => {
            Object.keys(uObj).forEach(updateKey => {
                // console.log('calling dispatch')
                if (uObj[updateKey].length === 1) {
                    dispatch(apiSingleAction(uObj[updateKey][0]))
                } else {
                    dispatch(apiListAction(uObj[updateKey]))
                }
            })
        }
    }
}

export const fakeActionCall = (action, data) => {
    return dispatch => {
        dispatch(apiAction(action, data))
    }
}

export const callApi = (routeObj, data, formId = -1) => {
    return dispatch => {
        dispatch(upsertForm(formId, formStates.PROCESSING))
        const auth = getAuth()
        if (!auth.currentUser) {
            dispatch(manageApiData(data))
            if (formId !== -1) {
                dispatch(upsertForm(formId, formStates.SUCCESS, 'id' in data ? data.id : formId))
            }
        } else {
            return auth.currentUser.getIdToken()
                .then(token => {
                    let query = ''
                    let fetchParams = {
                        headers: {
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': `Bearer ${token}`
                        },
                        method: routeObj.method
                    }
                    if (routeObj.method === API_METHODS.GET) {
                        query = Object.keys(data).map(key => {
                            return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
                        }).join('&')
                        if (query !== '') {
                            query = `?${query}`
                        }
                    } else if (routeObj.method === API_METHODS.POST) {
                        fetchParams.body = JSON.stringify(data)
                    }
                    let apiRoute = buildRoutePath(routeObj.url, routeObj.params)
                    const apiUrl = `${API_URL}${apiRoute}${query}`
                    return fetch(apiUrl, fetchParams)
                })
                .then(response => {
                    return Promise.all([response, response.json()])
                })
                .then(([response, result]) => {
                    if (response.ok) {
                        if (routeObj.method === API_METHODS.DELETE) {
                            dispatch(apiRemoveAction(result.data))
                        } else {
                            dispatch(manageApiData(result.data))
                        }
                        dispatch(upsertForm(formId, formStates.SUCCESS, result.data.id))
                    } else {
                        if (result.code) {
                            throw new Error(`${result.code}: ${result.errors}`)
                        }
                        // this should handle the responses from validation endpoints
                        let msgs = []
                        Object.keys(result).forEach(key => {
                            msgs.push(result[key].join(', '))
                        })
                        throw new Error(msgs.join(', '))
                    }
                })
                .catch(err => {
                    // TODO: need to log this?
                    dispatch(upsertForm(formId, formStates.ERROR, err.message))
                })
        }
    }
}

export const callFileApi = (routeObj, data, formId) => {
    return dispatch => {
        dispatch(upsertForm(formId, formStates.PROCESSING))
        const auth = getAuth()
        return auth.currentUser.getIdToken()
            .then(token => {
                const fetchParams = {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    method: 'POST',
                    body: data
                }
                let apiRoute = buildRoutePath(routeObj.url, routeObj.params)
                const apiUrl = `${API_URL}${apiRoute}`
                return fetch(apiUrl, fetchParams)
            })
            .then(response => {
                return Promise.all([response, response.json()])
            })
            .then(([response, result]) => {
                if (response.ok) {
                    dispatch(upsertForm(formId, formStates.SUCCESS, result.data.id))
                    dispatch(manageApiData(result.data))
                } else {
                    throw new Error(`${result.code}: ${result.errors}`)
                }
            })
            .catch(err => {
                console.log('error in file upload')
                dispatch(upsertForm(formId, formStates.ERROR, err.message))
            })
    }
}

export const fetchFileViaApi = (routeUrl, filename) => {
    return dispatch => {
        const auth = getAuth()
        return auth.currentUser.getIdToken()
            .then(token => {
                let fetchParams = {
                    headers: { Authorization: `Bearer ${token}` },
                    method: 'GET'
                }
                const apiUrl = `${API_URL}${routeUrl}`
                return fetch(apiUrl, fetchParams)
            })
            .then(response => {
                return Promise.all([response, response.blob()])
            })
            .then(([response, blob]) => {
                if (response.ok) {
                    const url = window.URL.createObjectURL(new Blob([blob]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', filename)
                    document.body.appendChild(link)
                    link.click()
                    link.parentNode.removeChild(link)
                    dispatch({ type: 'FILE_DOWNLOADED' })
                } else {
                    throw new Error('Problem attempting to download file.')
                }
            })
            .catch(err => {
                console.log('something went wrong... ', err)
            })
    }
}

const requestFetch = (routeUrl) => {
    return {
        type: 'SAVE_API_CALL',
        data: {
            url: routeUrl,
            isFetching: true,
            hasError: false
        }
    }
}

const receiveFetch = (routeUrl) => {
    return {
        type: 'SAVE_API_CALL',
        data: {
            url: routeUrl,
            isFetching: false,
            hasError: false,
            lastFetch: moment().format()
        }
    }
}

const fetchError = (routeUrl, error) => {
    return {
        type: 'SAVE_API_CALL',
        data: {
            url: routeUrl,
            isFetching: false,
            hasError: true,
            lastFetch: moment().format(),
            error
        }
    }
}

export const clearApiFetch = (routeUrl) => {
    return {
        type: 'CLEAR_API_CALL',
        data: {
            url: routeUrl
        }
    }
}

export const fetchPublicApiData = (routeObj, data) => {
    return dispatch => {
        let query = ''
        let fetchParams = {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            method: routeObj.method
        }
        if (routeObj.method === API_METHODS.GET) {
            query = Object.keys(data).map(key => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }).join('&')
            if (query !== '') {
                query = `?${query}`
            }
        } else if (routeObj.method === API_METHODS.POST) {
            fetchParams.body = JSON.stringify(data)
        }
        let apiRoute = buildRoutePath(routeObj.url, routeObj.params)
        const apiUrl = `${API_URL}${apiRoute}${query}`
        dispatch(requestFetch(apiUrl))
        return fetch(apiUrl, fetchParams)
            .then(response => {
                return Promise.all([response, response.json()])
            })
            .then(([response, result]) => {
                if (response.ok) {
                    dispatch(receiveFetch(apiUrl))
                    dispatch(manageApiData(result.data))
                } else {
                    // dispatch(setErrorCode(result.code))
                    throw new Error(`${result.code}: ${result.errors}`)
                }
            })
            .catch(err => {
                console.log('error in public fetch...')
                dispatch(fetchError(apiUrl, err.message))
            })
    }
}

export const fetchConfigData = (routeUrl, params = {}) => {
    const auth = getAuth()
    return auth.currentUser.getIdToken()
        .then(token => {
            let fetchParams = {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Authorization': `Bearer ${token}`
                },
                method: 'GET'
            }
            let query = ''
            query = Object.keys(params).map(key => {
                if (Array.isArray(params[key])) {
                    return params[key].map(ad => {
                        return encodeURIComponent(key) + '[]=' + encodeURIComponent(ad)
                    }).join('&')
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            }).join('&')
            if (query !== '') {
                query = `?${query}`
            }
            const apiUrl = `${API_URL}${routeUrl}${query}`
            return fetch(apiUrl, fetchParams)
        })
        .then(response => {
            return Promise.all([response, response.json()])
        })
        .then(([response, result]) => {
            if (response.ok) {
                return result.data
            }
            return Promise.resolve()
        })
        .catch(err => {
            // TODO: need to log this?
            // dispatch(fetchError(routeUrl, err.message))
            console.log('blah')
        })
}

// TODO: Need to be able to handle query paramters, like for pagination, etc.
const fetchApiData = (routeUrl, params) => {
    return dispatch => {
        // dispatch the isLoading....
        dispatch(requestFetch(routeUrl))
        const auth = getAuth()
        return auth.currentUser.getIdToken()
            .then(token => {
                let query = ''
                let fetchParams = {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'Authorization': `Bearer ${token}`
                    },
                    method: 'GET'
                }
                query = Object.keys(params).map(key => {
                    if (Array.isArray(params[key])) {
                        return params[key].map(ad => {
                            return encodeURIComponent(key) + '[]=' + encodeURIComponent(ad)
                        }).join('&')
                    }
                    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                }).join('&')
                if (query !== '') {
                    query = `?${query}`
                }
                const apiUrl = `${API_URL}${routeUrl}${query}`
                return fetch(apiUrl, fetchParams)
            })
            .then(response => {
                return Promise.all([response, response.json()])
            })
            .then(([response, result]) => {
                if (response.ok) {
                    dispatch(receiveFetch(routeUrl))
                    dispatch(manageApiData(result.data))
                } else {
                    throw new Error(`${result.code}: ${result.errors}`)
                }
                return Promise.resolve()
            })
            .catch(err => {
                // TODO: need to log this?
                dispatch(fetchError(routeUrl, err.message))
            })
    }
}

const shouldFetchApiData = (apiCaches, routeUrl) => {
    const cachedRoute = apiCaches.find(cache => cache.get('url') === routeUrl)
    if (!cachedRoute) {
        return true
    } else if (cachedRoute.get('isFetching')) {
        return false
    }
    if (!cachedRoute.has('lastFetch')) {
        return true
    }
    const lastFetch = moment(cachedRoute.get('lastFetch'))
    const lapsedTime = moment().diff(lastFetch, 's', true)
    // TODO: make this an environment variable?
    if (lapsedTime < 5) {
        return false
    }
    return true
}

export const fetchApiDataIfNeeded = (routeObj, params = {}, force = false) => {
    const routeUrl = buildRoutePath(routeObj.url, params)
    return (dispatch, getState) => {
        if (shouldFetchApiData(getState().get('apiCaches'), routeUrl) || force) {
            dispatch(fetchApiData(routeUrl, params))
        }
    }
}

export const deleteViaApi = (routeObj, params = {}) => {
    const routeUrl = buildRoutePath(routeObj.url, params)
    const deleteUrl = `/delete${routeUrl}`
    return dispatch => {
        dispatch(requestFetch(deleteUrl))
        const auth = getAuth()
        return auth.currentUser.getIdToken()
            .then(token => {
                let fetchParams = {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'Authorization': `Bearer ${token}`
                    },
                    method: 'DELETE'
                }
                const apiUrl = `${API_URL}${routeUrl}`
                return fetch(apiUrl, fetchParams)
            })
            .then(response => {
                return Promise.all([response, response.json()])
            })
            .then(([response, result]) => {
                if (response.ok) {
                    dispatch(receiveFetch(deleteUrl))
                    dispatch(apiAction(routeObj.action, result.data))
                } else {
                    throw new Error(`${result.code}: ${result.errors}`)
                }
                return Promise.resolve()
            })
            .catch(err => {
                dispatch(fetchError(deleteUrl, err.message))
            })
    }
}
